import { Namespace } from "@cirrus/fe-lib"

import { CoreConfig } from "../_params.js"

const localeIconPathFor = (country) => `/static/img/flags/${country}.svg`

export const I18nConfig = {
  domain: Namespace.domain(CoreConfig, "i18n"),

  availableLanguages: {
    "de-DE": "Deutsch",
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "fr-CA": "Français (Canada)",
    "nl-NL": "Dutch (Nederlands)",
  },

  locales: {
    byCode: {
      "en-GB": {
        id: "en_GB",
        code: "en-GB",
        shorthand: "en",
        key: "UnitedKingdom",
        icon: localeIconPathFor("united-kingdom"),
        speakerVoice: "Alice",
      },

      "en-US": {
        id: "en_US",
        code: "en-US",
        shorthand: "en",
        key: "USA",
        icon: localeIconPathFor("united-states"),
        speakerVoice: "Sophie",
      },

      "de-DE": {
        id: "de_DE",
        code: "de-DE",
        shorthand: "de",
        key: "Germany",
        icon: localeIconPathFor("germany"),
        speakerVoice: "Max",
      },

      "fr-CA": {
        id: "fr_CA",
        code: "fr-CA",
        shorthand: "fr",
        key: "FrenchCanada",
        icon: localeIconPathFor("france"),
        speakerVoice: "Chloe",
      },

      "nl-NL": {
        id: "nl_NL",
        code: "nl-NL",
        shorthand: "nl",
        key: "Netherlands",
        icon: localeIconPathFor("netherlands"),
        speakerVoice: "Ilse",
      },
    },
  },
}
